import { useCanEditModule } from '@/auth/useCanEditModule'

/**
 * The module whose `edit` grant lets a session change a deal. The writes the
 * dossier and the Pipeline inspector make from their edit controls — the one
 * Save (PUT /loans/{id}), a journal note (POST /loans/{id}/notes) and a field
 * approval (POST /loans/{id}/fields/{name}/approve) — are each guarded by
 * require_permission("pipeline", "edit") in backend/app/api/v1/loans.py.
 */
export const DEAL_EDIT_MODULE = 'pipeline'

/** Said where an edit control is drawn for a role that may not use it. */
export const NO_DEAL_EDIT = 'Your role can view this deal but not edit it.'

/**
 * Whether this session may edit a deal: the same /auth/me grant the API
 * enforces, read through useCanEditModule so a local session and an Entra
 * session answer alike. A viewer is never offered an edit it would only learn
 * was refused after typing and pressing Save.
 */
export function useCanEditDeal(): boolean {
  return useCanEditModule(DEAL_EDIT_MODULE)
}
